export const apiConstants = {
  /* The API URL */
  apiUrl: 'https://csapi.compsg.dev/api/v1',

  /* Indexes for the array of the user's data */
  userIndex: 0,
  passIndex: 1,
  accountIndex: 2,
};

export const appConstants = {
  toolbarContentSize: '0.92rem',
  toolbarFont: 'Ubuntu',
  toolbarColor: '#CBCDBC',
  toolbarHeight: 20,

  /* The default values for the user's data */
  passwordMinLength: 5,
  passwordMaxLength: 25,
  emailMaxLength: 100,
};
